import axios from 'axios';

// import redirectToMaintenancePage from '../utils/redirectToMaintenancePage';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// redirectToMaintenancePage(); // if server is in maintenance

export function getReferencesData(rateId, rank, dutyState) {
  return axios
    .get(
      `${BASE_URL}/referenceData?rate=${rateId}&rank=${rank}&dutyState=${dutyState}`,
    )
    .then(({ data }) => data);
}

export function getQualsDataService() {
  return axios.get(`${BASE_URL}/getQualsData`).then(({ data }) => data);
}

export function getPlans() {
  return axios.get(`${BASE_URL}/subscription/plans`).then(({ data }) => data);
}

export async function checkEmailExists(email) {
  return axios
    .get(`${BASE_URL}/checkPricingEmailExists?email=${email}`)
    .then(({ data }) => data);
}

export async function checkCoupon(coupon, planId, isTrialUser = true, userId) {
  return axios
    .get(
      `${BASE_URL}/checkCoupon?couponName=${coupon}&planId=${planId}&isTrialing=${isTrialUser}`,
      {
        params: {
          userId,
        },
      },
    )
    .then(({ data }) => data);
}

export function subscribeUser(user) {
  return axios.post(`${BASE_URL}/subscription/`, user).then(({ data }) => data);
}

export function loadRatingExamQuestions(rate) {
  const URL = BASE_URL.substring(0, BASE_URL.lastIndexOf('/'));
  return axios
    .get(`${URL}/rate/${rate}/getRatingExamQuestions`)
    .then(({ data }) => data);
}

export function signUpFreeAccount(userData) {
  return axios
    .post(`${BASE_URL}/suscribeFree/`, userData)
    .then(({ data }) => data);
}
